import { Link } from "react-router-dom";

export default function SocialLink({
  hidden,
  internal,
  alt,
  url,
  icon,
}: {
  hidden?: boolean;
  internal?: boolean;
  alt: string;
  url: string;
  icon: string;
}) {
  const iconMarkup = <img src={icon} className="icon" alt={alt} />;

  if (hidden) {
    return null;
  }

  if (internal) {
    return <Link to={url}>{iconMarkup}</Link>;
  }

  return (
    <a href={url} target="_blank" rel="noreferrer">
      {iconMarkup}
    </a>
  );
}
